import { Helmet } from "react-helmet-async"
import React, { useState } from "react"
import Calendly from "../Calendly"
import Input from "../Input"
import { api, validatePayload } from "../../util"
import "./Contact.css"

export default function Contact() {
			const schema = {
		"@context": "https://schema.org",
		"@type": "Product",
		"name": "Salusion Referral Program | Earn $42 Per Participant ",
		"description": "Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients.",
		"brand": {
			"@type": "Brand",
			"name": "Salusion"
		},
		"offers": [
			{
				"@type": "Offer",
				"name": "ICHRA",
				"description": "Individual Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "QSEHRA",
				"description": "Qualified Small Employer Health Reimbursement Arrangement (QSEHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "GCHRA",
				"description": "Group Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "5.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "5.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "EBHRA",
				"description": "Excepted Benefit Health Reimbursement Arrangement (ICHRA)",
				"price": "5.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "5.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
		],
		"image": "https://salusion.com/assets/images/Generic.png",
		"url": "https://salusion.com",
	}
	const [contact, setContact] = useState(() => getBlankContact())
	const [errors, setErrors] = useState(() => [])
	const [notification, setNotification] = useState(() => false)

	function getBlankContact() {
		return { name: "", email: "", message: "" }
	}

	function handleInput(event) {
		const { name, value } = event.target

		const updatedContact = { ...contact, [name]: value }
		const errors = validatePayload(updatedContact)

		setContact(updatedContact)
		setErrors(errors)
	}

	async function handleSubmit(event) {
		event.preventDefault()

		if (!errors.length) {
			const url = "send/webContact"
			await api.post({ url, data: contact })

			setContact(getBlankContact())
			setNotification(true)

			setTimeout(() => {
				setNotification(false)
			}, 3000)
		}
	}

	return (
		<>
			<Helmet>
				<title>Contact Salusion | HRA Experts | ICHRA, QSEHRA, GCHRA, and EBHRA</title>
				<meta name="title" content="Contact Salusion | HRA Experts | ICHRA, QSEHRA, GCHRA, and EBHRA" />
				<meta name="description" content="Get in touch with Salusion’s HRA specialists to schedule a consultation or ask about ICHRA, QSEHRA, GCHRA & EBHRA options. Expert support for your small business benefits." />
				<meta name="keywords" content="Small Business HRA administration software, ICHRA, QSEHRA, Affordable HRA, tax-free benefit, GCHRA, EBHRA" />
				<link rel="canonical" href="https://salusion.com" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@Salusion" />
				<meta name="twitter:title" content="Contact Salusion | HRA Experts | ICHRA, QSEHRA, GCHRA, and EBHRA" />
				<meta name="twitter:description" content="Get in touch with Salusion’s HRA specialists to schedule a consultation or ask about ICHRA, QSEHRA, GCHRA & EBHRA options. Expert support for your small business benefits." />
				<meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />

				<meta property="og:title" content="Contact Salusion | HRA Experts | ICHRA, QSEHRA, GCHRA, and EBHRA" />
				<meta property="og:description" content="Get in touch with Salusion’s HRA specialists to schedule a consultation or ask about ICHRA, QSEHRA, GCHRA & EBHRA options. Expert support for your small business benefits." />
				<meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta property="og:image:alt" content="Salusion logo and healthcare savings" />
				<meta property="og:url" content="https://salusion.com/contact-us" />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Salusion" />
				<meta property="og:locale" content="en_US" />

				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>		<section id="contact" className="first-section first-padding">
				<div className="container">
					<div className="contact-wrapper white-wrapper-all">
						<h1>We Look Forward To Connecting With You</h1>

						<div className="contact-form-wrapper">
							<div className="row">
								<div className="col-12 col-md-7">
									<div style={{ textAlign: "center" }}>
										<h2>Schedule a call</h2>
										<Calendly calendarOnly={true} />
									</div>
								</div>

								<div className="col-12 col-md-5">
									<div style={{ textAlign: "center" }}>
										<h2>Send a message</h2>
										{notification && <p>Message sent successfully. We will respond to you shortly.</p>}

										<form className="form-all contact-form" onSubmit={handleSubmit}>
											<Input type="text" name="name" placeholder="Name" value={contact.name} onChange={handleInput} />
											<Input type="email" name="email" placeholder="Email" value={contact.email} onChange={handleInput} />

											<div className="col-12">
												<div className="form-group">
													<textarea
														className="form-control"
														name="message"
														placeholder="Message"
														value={contact.message}
														onChange={handleInput}
													/>
												</div>
											</div>

											<button type="submit">Send Message</button>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
